import api from "../Auth/axiosInstance";

const CatchError = (error) => {
  return { Status: false, Response_Code: 404, Response_Message: error.message };
};

export const UserLogin = async (Data) => {
  try {
    const Form = new FormData();
    Form.append("email", Data.Email);
    Form.append("password", Data.Password);
    const Result = await api.post("/login", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const LogoutApi = async () => {
  try {
    const Response = await api.post("/logout");
    return Response;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampsAll = async (data) => {
  try {
    const Response = await api.post("/stamps/all");
    return Response;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampsDelete = async (id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    const Result = await api.post("/stamps/delete", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampIsPremium = async (ispremium, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("is_premium", ispremium);
    const Result = await api.post("/stamps/ispremium/update", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampIsPremiumIos = async (ispremiumios, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("is_premium_ios", ispremiumios);
    const Result = await api.post("/stamps/ispremiumios/update", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampStatus = async (status, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("status", status);
    const Result = await api.post("/stamps/status/update", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampStatusIos = async (statusios, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("status_ios", statusios);
    const Result = await api.post("/stamps/statusios/update", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampView = async (id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    const Result = await api.post("/stamps/view", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampAdd = async (data) => {
  try {
    const Form = new FormData();
    Form.append("main_image", data.main_image);
    Form.append("front_image", data.front_image);
    Form.append("zip_name", data.zip_name);
    Form.append("zip_name_ios", data.zip_name_ios);
    Form.append("is_premium", data.is_premium);
    Form.append("is_premium_ios", data.is_premium_ios);
    Form.append("status", data.status);
    Form.append("status_ios", data.status_ios);
    const Result = await api.post("/stamps/add", Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const StampEdit = async (data, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("main_image", data.main_image);
    Form.append("front_image", data.front_image);
    Form.append("zip_name", data.zip_name);
    Form.append("zip_name_ios", data.zip_name_ios);
    Form.append("is_premium", data.is_premium);
    Form.append("is_premium_ios", data.is_premium_ios);
    Form.append("status", data.status);
    Form.append("status_ios", data.status_ios);
    const Result = await api.post(`/stamps/update`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewsAll = async (data) => {
  try {
    const Response = await api.post(`/news/all`);
    return Response;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewsDelete = async (id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    const Result = await api.post(`/news/delete`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewsSearch = async (title) => {
  try {
    const Form = new FormData();
    Form.append("title", title);
    const Result = await api.post(`/news/search`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewsStatus = async (is_active, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("is_active", is_active);
    const Result = await api.post(`/news/status/update`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewView = async (id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    const Result = await api.post(`/news/view`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewAdd = async (data, images) => {
  try {
    const Form = new FormData();
    Form.append("title", data.title);
    Form.append("header", data.header);
    Form.append("short_description", data.short_description);
    Form.append("description", data.description);
    Form.append("latitude", data.latitude);
    Form.append("longitude", data.longitude);
    Form.append("location_name", data.location_name);
    Form.append("is_active", data.is_active);

    images.map((val, index) => {
      Form.append("image", val);
    });

    const Result = await api.post(`/news/add`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewUpdate = async (id, data, addimages, deleteimages) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("title", data.title);
    Form.append("header", data.header);
    Form.append("short_description", data.short_description);
    Form.append("description", data.description);
    Form.append("latitude", data.latitude);
    Form.append("longitude", data.longitude);
    Form.append("location_name", data.location_name);
    Form.append("is_active", data.is_active);
    Form.append("deleteimage", JSON.stringify(deleteimages));

    addimages.map((val, index) => {
      Form.append("image", val);
    });

    const Result = await api.post(`/news/update`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const NewsWebViews = async (title) => {
  try {
    const Form = new FormData();
    Form.append("title", title);
    const Result = await api.post(`/destination/title`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

/* ── Blog module ───────────────────────────────────────────────────────────
 *
 * The blog endpoints answer validation failures with HTTP 422/409 and a
 * { Status, Response_Code, Response_Message, Errors } body, and axios rejects
 * on any non-2xx. The shared CatchError above would drop that body (and returns
 * an object with no `.data`, which then throws in the caller), so these helpers
 * use their own catch that preserves the server's response and always resolves
 * to a `{ data }` shape. Callers can therefore rely on
 * `Result.data.Status` / `Result.data.Errors` in every outcome, including a
 * network failure.
 */
const BlogCatchError = (error) => ({
  data:
    error?.response?.data || {
      Status: false,
      Response_Code: error?.response?.status || 0,
      Response_Message:
        error?.message === "Network Error"
          ? "Cannot reach the server. Check your connection and try again."
          : error?.message || "Something went wrong. Please try again.",
      Errors: {},
    },
});

/** Builds the multipart payload shared by add and update. */
const BlogFormData = (data, coverFile) => {
  const Form = new FormData();
  Form.append("title", data.title ?? "");
  Form.append("slug", data.slug ?? "");
  Form.append("excerpt", data.excerpt ?? "");
  // SEO meta description; the website falls back to excerpt when this is blank.
  Form.append("meta_description", data.meta_description ?? "");
  // SEO meta keywords, rendered verbatim into <meta name="keywords">.
  Form.append("meta_keywords", data.meta_keywords ?? "");
  // Raw JSON-LD pasted by the admin; blank clears back to the default schema.
  Form.append("custom_schema", data.custom_schema ?? "");
  Form.append("body", data.body ?? "");
  // A reference into the managed category list, not a name.
  Form.append("category_id", data.category_id ?? "");
  Form.append("author", data.author ?? "");
  Form.append("tags", JSON.stringify(data.tags ?? []));
  Form.append("published_at", data.published_at ?? "");
  // Blank means "estimate from the content" on the server.
  Form.append("reading_time", data.reading_time ?? "");
  // Hand-entered social-proof stats; blank means "not set" and saves as 0.
  Form.append("rating", data.rating ?? "");
  Form.append("readers_count", data.readers_count ?? "");
  Form.append("ratings_count", data.ratings_count ?? "");
  Form.append("is_active", data.is_active ? 1 : 0);
  // Alt text for the cover image. Sent alongside every save so it can be edited
  // independently of the image file — including cleared back to "".
  Form.append("cover_image_alt", data.cover_image_alt ?? "");
  // FAQs are embedded on the post and saved together with it: the heading and
  // the full ordered list travel on every save (add / edit / delete / reorder
  // are all captured by replacing the whole array server-side).
  Form.append("faq_title", data.faq_title ?? "");
  Form.append(
    "faqs",
    JSON.stringify(
      (data.faqs ?? []).map((f) => ({ question: f.question ?? "", answer: f.answer ?? "" }))
    )
  );
  // Only sent when the admin picked a new file; on update, omitting it keeps
  // the existing cover image.
  if (coverFile) Form.append("cover_image", coverFile);
  return Form;
};

export const BlogAll = async () => {
  try {
    return await api.post(`/blog/all`);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogSearch = async (title) => {
  try {
    const Form = new FormData();
    Form.append("title", title);
    return await api.post(`/blog/search`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogView = async (id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    return await api.post(`/blog/view`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogAdd = async (data, coverFile) => {
  try {
    return await api.post(`/blog/add`, BlogFormData(data, coverFile));
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogUpdate = async (id, data, coverFile) => {
  try {
    const Form = BlogFormData(data, coverFile);
    Form.append("_id", id);
    return await api.post(`/blog/update`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogDelete = async (id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    return await api.post(`/blog/delete`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogStatus = async (is_active, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("is_active", is_active);
    return await api.post(`/blog/status/update`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

/**
 * Uploads one image chosen inside the post body's rich-text editor; the editor's
 * upload adapter inserts the returned URL into the article HTML. `signal` lets
 * the adapter abort an in-flight upload when the editor cancels it.
 */
export const BlogUploadImage = async (file, signal) => {
  try {
    const Form = new FormData();
    Form.append("image", file);
    return await api.post(`/blog/upload-image`, Form, { signal });
  } catch (error) {
    return BlogCatchError(error);
  }
};

/* ── End Blog module ─────────────────────────────────────────────────────── */

/* ── Blog category module ─────────────────────────────────────────────────── */

/** Every category with its post counts, for the category table. */
export const BlogCategoryAll = async () => {
  try {
    return await api.post(`/blog/category/all`);
  } catch (error) {
    return BlogCatchError(error);
  }
};

/**
 * Categories offered in the post form's dropdown: the active ones, plus
 * `includeId` (the category the post being edited already uses) so editing an
 * old post in a retired category doesn't silently blank its category.
 */
export const BlogCategoryOptions = async (includeId) => {
  try {
    const Form = new FormData();
    if (includeId) Form.append("include", includeId);
    return await api.post(`/blog/category/options`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogCategoryView = async (id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    return await api.post(`/blog/category/view`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogCategoryAdd = async (data) => {
  try {
    const Form = new FormData();
    Form.append("name", data.name ?? "");
    Form.append("description", data.description ?? "");
    Form.append("is_active", data.is_active ? 1 : 0);
    return await api.post(`/blog/category/add`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogCategoryUpdate = async (id, data) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("name", data.name ?? "");
    Form.append("description", data.description ?? "");
    Form.append("is_active", data.is_active ? 1 : 0);
    return await api.post(`/blog/category/update`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

/** `reassignTo` moves the category's posts before deleting it. */
export const BlogCategoryDelete = async (id, reassignTo) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    if (reassignTo) Form.append("reassign_to", reassignTo);
    return await api.post(`/blog/category/delete`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

export const BlogCategoryStatus = async (is_active, id) => {
  try {
    const Form = new FormData();
    Form.append("_id", id);
    Form.append("is_active", is_active);
    return await api.post(`/blog/category/status/update`, Form);
  } catch (error) {
    return BlogCatchError(error);
  }
};

/* ── End Blog category module ────────────────────────────────────────────── */

/* Blog FAQs are no longer a separate module: they are embedded on the post and
 * sent with the blog add/update payload (see BlogFormData above). */

export const kml_upload = async (kml) => {
  try {
    const Form = new FormData();
    Form.append("kml", kml);
    const Result = await api.post(`/kml_upload`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const ios_kml = async (kml) => {
  try {
    const Form = new FormData();
    Form.append("kml", kml);
    const Result = await api.post(`/ios_kml`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};
export const getUsers = async (page, pageSize) => {
  try {
    const Form = new FormData();
    Form.append("page", page);
    Form.append("limit", pageSize);
    const Result = await api.post(`/getUserDetail`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};
export const getUserAllDetail = async (email) => {
  try {
    const Form = new FormData();
    Form.append("email", email);
    const Result = await api.post(`/getUserAllDetail`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};
export const getUserDetailByEmail = async (email) => {
  try {
    const Form = new FormData();
    Form.append("email", email);
    const Result = await api.post(`/getUserDetailByEmail`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};
export const getUserEmails = async (email) => {
  try {
    const Form = new FormData();
    Form.append("email", email);
    const Result = await api.post(`/getUserEmails`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};
export const searchUsers = async (email, page, limit) => {
  try {
    const Form = new FormData();
    Form.append("email", email);
    Form.append("page", page);
    Form.append("limit", limit);
    const Result = await api.post(`/getUserSearch`, Form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};
export const getUserFilterData = async (form) => {
  try {
    const Result = await api.post(`/getUserFilterData`, form);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};

export const contactUs = async (payload) => {
  try {
    const Result = await api.post(`/contact-us`, payload);
    return Result;
  } catch (error) {
    return CatchError(error);
  }
};
